module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-privacy"
  }, [_c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "text-center headline-container"
  }, [_c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "headline"
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), (_vm.privacy.length) ? _c('div', {
    staticClass: "container block-text",
    domProps: {
      "innerHTML": _vm._s(_vm.privacy)
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6155d01c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Privacy.vue
// module id = 1530
// module chunks = 0